import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EditEngagementComponent } from './edit-engagement.component';

const routes: Routes = [
  {
    path: '',
    component: EditEngagementComponent,
    data: { Title: 'Edit Engagement' }// canActivate: [RouteGuard]
  }
];

@NgModule({

  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class EditEngagementRoutingModule { }
